import { API_NODE_URL } from '~/constants';
import api from '~/services/api';

class AssinaturaService {
  getAssinaturaByDocumento({ tipoDocumento, documentoId }, opts) {
    return api.get(
      `${API_NODE_URL}/integracao/assinatura/documento/${tipoDocumento}/${documentoId}`,
      opts
    );
  }

  salvarAssinaturaByDocumento(
    {
      tipoDocumento,
      documentoId,
      assinatura
    },
    opts
  ) {
    return api.put(
      `${API_NODE_URL}/integracao/assinatura/documento/${tipoDocumento}/${documentoId}`,
      {
        assinatura
      },
      opts
    );
  }

  removerAssinaturaByDocumento({ tipoDocumento, documentoId }, opts) {
    return api.delete(
      `${API_NODE_URL}/integracao/assinatura/documento/${tipoDocumento}/${documentoId}`,
      opts
    );
  }
}

export default new AssinaturaService();